import React from "react";

function NavigationButtons({ onPrev, onNext, disablePrev, disableNext }) {
    return (
        <div style={{ textAlign: "center", margin: "0.5rem 0" }}>
            <button onClick={onPrev} disabled={disablePrev} style={{ marginRight: "1rem" }}>
                Previous
            </button>
            <button onClick={onNext} disabled={disableNext}>
                Next
            </button>
        </div>
    );
}

export default NavigationButtons;
